module.exports = __webpack_public_path__ + "img/ic_meat.0fce28d6.svg";